import { render, staticRenderFns } from "./PoveznicaDataForma.vue?vue&type=template&id=7cb64633&scoped=true&"
import script from "./PoveznicaDataForma.vue?vue&type=script&lang=js&"
export * from "./PoveznicaDataForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb64633",
  null
  
)

export default component.exports